// Soda Cleaning site entrypoint (sodacleaning.ca).
// Intentionally minimal — no chat widget, no address checker, no calculator.
// CSS is handled separately via cssbundling-rails.

// Mobile menu toggle (header). Opening also shows a scrim over the page and
// locks background scroll; the scrim click and Escape both close the menu.
const toggle = document.querySelector<HTMLButtonElement>("[data-menu-toggle]")
const menu = document.getElementById("mobile-menu")
const backdrop = document.querySelector<HTMLElement>("[data-menu-backdrop]")

if (toggle && menu) {
  const setMenuOpen = (open: boolean) => {
    menu.classList.toggle("hidden", !open)
    backdrop?.classList.toggle("hidden", !open)
    document.body.classList.toggle("overflow-hidden", open)
    toggle.setAttribute("aria-expanded", String(open))
  }

  toggle.addEventListener("click", () => setMenuOpen(menu.classList.contains("hidden")))
  backdrop?.addEventListener("click", () => setMenuOpen(false))
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !menu.classList.contains("hidden")) setMenuOpen(false)
  })
}
